module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7679e8aa3b5a6b745823e00a7b950065.png";